module.exports = __webpack_public_path__ + "static/media/23-speaker_profile.53a26985.webp";